import endpoints, { ENDPOINT_NAMES } from '../../config/endpoints';
import ASSIGNMENT_STATUS from '../../constants/assignment-status';
import DEFAULT_REFETCH_INTERVAL from '../../constants/default-refetch-interval';
import GRADE_IDS from '../../constants/grade-ids';
import { useData } from '@llt-frontend/react-fetch';

//

function _filterAssignments(assignmentData, courseId, subjectId) {
  // filter by course id if included
  // filter by subject id if included
  // if subject id is not included filter out assignments related to camps and clubs
  return assignmentData.filter(
    (assignment) =>
      (!courseId ||
        (assignment.course.course_id
          ? courseId === assignment.course.course_id
          : courseId === `${assignment.tutor_id}-${assignment.skill.subject_id}`)) &&
      ((!subjectId &&
        !assignment.skill?.grades?.some((grade) =>
          [GRADE_IDS.camps, GRADE_IDS.clubs].includes(grade.id)
        )) ||
        subjectId === assignment.skill.subject_id)
  );
}

// Exports
// -------

export default function useAssignments({
  courseId,
  refetchInterval = DEFAULT_REFETCH_INTERVAL,
  sortOrder = 'desc',
  studentId,
  subjectId,
}) {
  const assignmentsEndpoint = endpoints.get(ENDPOINT_NAMES.studentAssignments, { studentId });

  const assignments = useData(assignmentsEndpoint.path, {
    queryKey: assignmentsEndpoint.key,
    queryOptions: {
      keepPreviousData: true,
      refetchInterval,
      select(data) {
        if (!data) {
          return [];
        }

        data.sort((a, b) =>
          sortOrder === 'asc'
            ? new Date(a.created_at) - new Date(b.created_at)
            : new Date(b.created_at) - new Date(a.created_at)
        );

        return _filterAssignments(data, courseId, subjectId);
      },
    },
  });

  //
  // Result

  return {
    ...assignments,

    get completedAssignments() {
      return assignments.data?.filter((assignment) =>
        ASSIGNMENT_STATUS.groupings.wrapUp.includes(assignment.status)
      );
    },

    get courseName() {
      return (
        assignments.data?.[0] &&
        (assignments.data?.[0].course.course_name ||
          `${assignments.data?.[0].display_name} - ${assignments.data?.[0].skill.subject_name}`)
      );
    },

    get remainingAssignments() {
      return assignments.data?.filter(
        (assignment) => !ASSIGNMENT_STATUS.groupings.wrapUp.includes(assignment.status)
      );
    },
  };
}
